import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContactHero from './components/ContactHero';
import QuickContactCards from './components/QuickContactCards';
import ContactForm from './components/ContactForm';
import LocationMap from './components/LocationMap';
import FAQSection from './components/FAQSection';
import EmergencyContact from './components/EmergencyContact';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 pt-16">
        <ContactHero />
        <QuickContactCards />
        <ContactForm />
        <LocationMap />
        <EmergencyContact />
        <FAQSection />
      </main>

      <Footer />
    </div>
  );
};

export default Contact;